import { useSelector } from "react-redux";
import { useUpdateEffect } from "../../../hooks";
import { depMotKey } from "../../util/NL_fieldPatterns";
import { useGetCustomsOfficeDS } from "../useGetCustomsOfficeDS";


export const useValidateDepMotUsingCustOfc=(mot='',validateError,fieldPattern)=>{
    const customOfficeList = useGetCustomsOfficeDS()
    const motError=useSelector((state)=>state.ValidationErrors.header?.[depMotKey]?.msg)
    useUpdateEffect(()=>{
    validateError({[`${depMotKey}`]:""},{transportation:{departureTransitMode:mot}},{[depMotKey]:fieldPattern({customsOffice:customOfficeList,mot}).header[depMotKey]})
    
    },[customOfficeList,mot])

    return motError
}